import { render, staticRenderFns } from "./xxtt.vue?vue&type=template&id=67a452ae&scoped=true"
import script from "./xxtt.vue?vue&type=script&lang=js"
export * from "./xxtt.vue?vue&type=script&lang=js"
import style0 from "./xxtt.vue?vue&type=style&index=0&id=67a452ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a452ae",
  null
  
)

export default component.exports